module.exports = __webpack_public_path__ + "fonts/14831.afd4b2ec.ttf";